module.exports = __webpack_public_path__ + "static/media/rewards-placeholder.c9842d25.png";